import { NavigationGuardWithThis } from "vue-router";
import { useUserStore } from "@/store/user";
const handlePowerRouteHandle: NavigationGuardWithThis<any> = (_to, _from, next) => {
  const userStore = useUserStore();
  if (userStore.isGroupLogin) {
    return next({ name: "group-space", replace: true });
  }

  return next();
};

export default handlePowerRouteHandle;
